/**
 *
 * @param {node} element
 * @param {array} refArray
 */

export default (element, refArray) => {
  if (element && !refArray.current.hasOwnProperty(element.id)) {
    refArray.current[element.id] = element
  }
}
